import type { PositionedItem } from '../components/PageConfigProvider/types/item';
import type { MetricValues } from '../components/PageConfigProvider/types/metric';
import { companySentimentDefaultMetric } from '../templates/company/company-sentiment';
import { geographySentimentDefaultMetric } from '../templates/geo/geography-sentiment';
import { industrySentimentDefaultMetric } from '../templates/industry/industry-sentiment';
import { roleSentimentDefaultMetric } from '../templates/role/role-sentiment';

export const getRevelioPageOverrides = (item: PositionedItem) => {
  const id = item?.id;

  const colorOverride = getColorOverride(id);
  const defaultMetric = getDefaultMetricOverrides(item);

  return {
    colorOverride,
    defaultMetric,
  };
};

const getColorOverride = (id: string) => {
  if (id === 'company-overview-salary-distribution') {
    return '#70CA97';
  }

  return undefined;
};

// A prescribed set of metric values we care to detect in a chart item id.
const defaultMetricOverrides: Record<string, MetricValues> = {
  'company-overview-competitors-headcount': 'headcount',
  ...companySentimentDefaultMetric,
  ...industrySentimentDefaultMetric,
  ...geographySentimentDefaultMetric,
  ...roleSentimentDefaultMetric,
};

const getDefaultMetricOverrides = (
  item: PositionedItem
): MetricValues | undefined => {
  const itemId = item?.id;

  if (!itemId) return undefined;

  if (defaultMetricOverrides[itemId]) {
    return defaultMetricOverrides[itemId];
  }

  const options = item?.plot?.defaultMetricOptions;
  if (!options || options.length === 0) return undefined;
  return options[0];
};
